<template>
  <div class="header_box d_flex align_items_center justify_content_center">
    <div class="position_relative logo_box">
      <img class="logo" src="~@/assets/logo.png" alt="" />
    </div>
    <ul class="d_flex">
      <li
        v-for="(item, index) in data"
        :key="index"
        @click="changeNav(index + '', item)"
        :class="{ active: currentActive.includes(item.path), navItem: true }"
      >
        <div class="nav_li d_flex align_items_center">
          <span>{{ item.text }}</span>
          <i class="el-icon-arrow-down" v-if="item.chlidren"></i>
        </div>
        <ul v-if="item.chlidren" class="chlid_list">
          <li
            class="text_center"
            v-for="(items, idx) in item.chlidren"
            :key="idx"
            @click.stop="changeNav(index + '-' + idx, items)"
          >
            {{ items.text }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      data: [
        {
          text: "首页",
          path: "/index"
        },
        {
          text: "多拉打印",
          path: "/print",
          chlidren: [
            {
              text: "高校打印",
              path: "/print/college"
            },
            {
              text: "便民打印",
              path: "/print/convenience"
            },
            {
              text: "多拉宝盒",
              path: "/print/box"
            }
          ]
        },
        // {
        //   text: "美发",
        //   path: "/aa5"
        // },
        {
          text: "产品中心",
          path: "/product/list"
        },
        {
          text: "合作加盟",
          path: "/cooperation-join"
        },
        {
          text: "关于我们",
          path: "/about-us"
        },
        {
          text: "常见问题",
          path: "/faq/list"
        }
      ],
      currentActive: "/index"
    };
  },
  watch: {
    $route: {
      handler(newVal) {
        this.currentActive = newVal.path;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeNav(id, event) {
      if (event.chlidren || !event.path || event.path === this.currentActive) {
        return;
      }
      this.currentActive = event.path;
      this.$router.push(event.path);
    }
  }
};
</script>

<style scoped lang="scss">
.header_box {
  width: 1200px;
  height: 66px;
  margin: 0 auto;
  .logo_box {
    margin-right: 192px;
  }
  .navItem {
    line-height: 35px;
    position: relative;
    cursor: pointer;
    .nav_li {
      color: #171717;
      padding: 0 30px;
      text-decoration: none;
      outline: none;
      font-size: 16px;
      font-weight: 600;
      i {
        margin-left: 7px;
      }
      span::after {
        content: "";
        display: block;
        margin-top: -3px;
        height: 2px;
        width: 60%;
        background: #ffffff !important;
        transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
      }
    }
    .chlid_list {
      display: none;
      position: absolute;
      width: 79px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 10px 16px 0px rgba(161, 161, 161, 0.27);
      z-index: 99;
      left: 20px;
      li {
        border-bottom: 1px solid #e0e0e0;
        font-size: 14px;
        font-weight: 500;
        color: #323232;
        height: 44px;
        line-height: 44px;
      }
      li:last-child {
        border: none;
      }
    }
  }
  .active {
    .nav_li {
      font-weight: 800;
      color: #fbe74e !important;
      span::after {
        background: #fbe74e !important;
      }
    }
  }
  .active:hover,
  .navItem:hover {
    a {
      ::after {
        width: 100%;
      }
    }
  }
  .navItem:hover {
    span,
    i {
      color: #fbe74e !important;
    }
    .nav_li {
      ::after {
        width: 100%;
        background: #fbe74e !important;
      }
    }
    .chlid_list {
      display: block;
      li:hover {
        background: #f2f2f2 none repeat scroll 0% 0%;
      }
      .chlid_active {
        background: #f2f2f2 none repeat scroll 0% 0%;
      }
    }
  }
}
</style>
